import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import RedirectingComponent from "src/chamber/components/RedirectingComponent";

function SupervisoryAssignerCard() {
  const { t } = useTranslation();

  const links = [
    {
      linkText: t("Νέα Ανάθεση Υ.Γ.Ε.ΜΗ."),
      linkTo: "/supervisoryTeam/createAssignment",
      badgeCount: null,
      filters: [],
    },
    {
      linkText: t("Διαχείριση Αναθέσεων"),
      linkTo: "/supervisoryTeam/assignerHistory",
      badgeCount: null,
      filters: [],
    },
  ];

  return (
    <Paper sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <ApartmentOutlinedIcon />
          {t("Εποπτεία Υπηρεσιών Γ.Ε.ΜΗ.")}
        </Typography>
      </Box>
      <Box
        sx={{
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          flex: 1,
        }}
      >
        {links.map((link) => (
          <RedirectingComponent key={link.linkTo} {...link} />
        ))}
      </Box>
    </Paper>
  );
}

export default SupervisoryAssignerCard;
